import { Component, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisplayDetails } from '@olv/ui-shared/models/display-details.interface';
import { FormatCoinCurrencyPipe } from '@olv/ui-shared/pipes/format-coin-currency.pipe';
import { ButtonComponent } from '@olv/ui-shared/ui-shared/button/button.component';
import { NetworkMetadataService } from '@olv/ui-shared/services/network-metadata.service';
import { symbolIcon, useFallbackIcon } from '@olv/ui-shared/utils/asset-balance.utils';

@Component({
  selector: 'app-summary-view',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, FormatCoinCurrencyPipe, ButtonComponent],
  templateUrl: './summary-view.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./summary-view.component.scss'],
})
export class SummaryViewComponent {
  protected readonly useFallbackIcon = useFallbackIcon;
  @Input() displayDetails: DisplayDetails = {
    currency: '',
    sourceWallet: '',
    sourceWalletName: '',
    amount: 0,
    targetWallet: '',
    targetWalletName: '',
    exchangeRate: 0,
    convertedAmount: 0,
    baseCurrencySymbol: '',
    baseCurrencyPrecision: 0,
    currencyPrecision: 0,
  };

  @Input() title = 'Withdrawal Summary';
  @Input() isLoading = false;
  @Input() isSettlementApp = true;

  @Output() cancelled = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();

  private readonly metadata = inject(NetworkMetadataService);

  constructor() {
    this.metadata.load();
  }

  getCurrencyIconPath(currency: string): string {
    return symbolIcon(currency, this.metadata);
  }
  getShortAddress(address: string, front = 8, back = 8): string {
    if (!address || address.length <= front + back) {
      return address;
    }
    const start = address.slice(0, front);
    const end = address.slice(-back);
    return `${start}...${end}`;
  }
  get cancelButtonState(): 'disabled' | 'default' {
    return this.isLoading ? 'disabled' : 'default';
  }

  get sendButtonState(): 'loading' | 'disabled' | 'default' {
    return this.isLoading ? 'loading' : 'default';
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  onConfirm(): void {
    if (!this.isLoading) {
      this.confirmed.emit();
    }
  }
}
